/**
 * What a host asks `CompanionThread` to do, once (#2266) — a send (a prompt
 * handed over from another page, a noticing CTA), a voice start, a fresh
 * thread. The thread acts on each request id exactly once.
 *
 * Its own module so `CompanionThread.tsx` exports components only
 * (`react-refresh/only-export-components`).
 */

// B-597: how long the skeleton may wait on a `connecting` stream before it
// says so. Long enough for the nonce fetch plus one SSE reconnect backoff
// (3 s), short enough that a dead stream is named within the time a parent
// would otherwise spend staring at placeholders.
export const CONNECT_STALL_MS = 10_000;

/** Something a host asks the thread to do, once. */
export type CompanionRequest =
  | { id: number; kind: 'send'; text: string }
  | { id: number; kind: 'voice' }
  | { id: number; kind: 'new' };

let nextRequestId = 1;

/** Mint a request with an id no other request in this tab carries. */
export function companionRequest(kind: 'send', text: string): CompanionRequest;
export function companionRequest(kind: 'voice' | 'new'): CompanionRequest;
export function companionRequest(kind: CompanionRequest['kind'], text?: string): CompanionRequest {
  const id = nextRequestId++;
  return kind === 'send' ? { id, kind, text: text ?? '' } : { id, kind };
}
